// BMIChildrenTable.js
import React from 'react';
function BMIChildrenTable({classification})  {
  return (
    <table >
      <thead>
        <tr>
          <th >Rentang Persentil</th>
          <th >Kategori Status Berat Badan</th>
        </tr>
      </thead>
      <tbody>
        <tr className={classification === 'Underweight' ? 'highlightedWarning' : ''}>
          <td>Kurang dari 5%</td>
          <td>Kekurangan Berat Badan (Underweight)</td>
        </tr>
        <tr className={classification === 'Healthy weight' ? 'highlightedOk' : ''}>
          <td>5% hingga 85%</td>
          <td>Berat Badan Sehat (Healthy weight)</td>
        </tr>
        <tr className={classification === 'At risk of overweight' ? 'highlightedWarning' : ''}>
          <td>85% hingga 95%</td>
          <td> Berisiko Kelebihan Berat Badan (At risk of overweight)</td>
        </tr>
        <tr className={classification === 'Overweight' ? 'highlightedDanger' : ''}>
          <td>Lebih besar atau sama dengan 95%</td>
          <td>Kelebihan Berat Badan (Overweight)</td>
        </tr>
        <tr>
          <td colSpan="2">
            <b>Sumber:</b>{' '} <br/>
            <a href="https://www.cdc.gov/bmi/faq/">
            Pusat Pengendalian dan Pencegahan Penyakit - Badan Kesehatan Masyarakat Nasional Amerika Serikat
            </a>
           </td>
        </tr>
        <tr>
          <td colSpan="2">
            <b>Tanggal Peninjauan Terakhir:</b> 28/02/2026
           </td>
        </tr>
      </tbody>
    </table>
  );
}
export default BMIChildrenTable;